import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

import { FadeInAnimation } from '../shared/fade-in.animation';

@Component({
  selector: 'app-save-dialog',
  templateUrl: './save-dialog.component.html',
  styleUrls: ['./save-dialog.component.scss'],
  animations: [FadeInAnimation]
})
export class SaveDialogComponent implements OnInit {

  name: string = "untitled";
  lock: boolean = false;
  public: boolean = true;
  
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() { }
  
}


// WEBPACK FOOTER //
// ./src/app/transfers/save-dialog.component.ts